import { memo, useEffect, useMemo, useState } from 'react';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import * as S from './style';

interface CustomColorType {
  textColor?: string;
}

type ColorType = 'white' | 'black' | 'gray' | CustomColorType | string;

interface IProps {
  brandName?: string;
  imgSrc?: string;
  priority?: boolean;
  rs?: string;
  value?: string;
  selectedValue?: string;
  colorType?: ColorType;
  onClick?: () => void;
}

const BrandSquareTabItem = ({
  brandName,
  imgSrc,
  priority,
  rs,
  value,
  selectedValue,
  colorType = 'white',
  onClick,
}: IProps) => {
  const [$value, setValue] = useState<string>(String(value));
  const [$selectedValue, setSelectedValue] = useState<string | undefined>(
    selectedValue
  );

  const isCustomColor = typeof colorType === 'object';
  const customColors = isCustomColor ? colorType : undefined;

  useEffect(() => {
    setValue(String(value));
  }, [value]);

  useEffect(() => {
    setSelectedValue(String(selectedValue));
  }, [selectedValue]);

  const cName = useMemo(
    () =>
      classNameBind([
        'brand-tab-item item',
        $value === $selectedValue ? 'active' : '',
        !isCustomColor ? `color-type-${colorType}` : '',
      ]),
    [$value, $selectedValue, colorType, isCustomColor]
  );

  return (
    <S.BrandSquareTabItem
      className={cName}
      $textColor={customColors?.textColor}
    >
      <Button onClick={onClick}>
        <Img
          src={getResizeImageUrl(imgSrc, rs)}
          alt={brandName}
          priority={priority}
        />
        <div className="text-wrap">
          <Text
            block
            weight={500}
            size={12}
            lineHeight="130%"
            align="center"
            color="#999"
            ellipsis={1}
          >
            {brandName}
          </Text>
        </div>
      </Button>
    </S.BrandSquareTabItem>
  );
};

export default memo(BrandSquareTabItem);
